import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerModello730ModalComponent} from './worker-modello-730-modal';

export const WorkerModello730ModalModule: string = ng
    .module('worker-modello_730-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerModello730ModalComponent', WorkerModello730ModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-modello-730-modal/worker-modello-730-modal.module.ts